import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { challengeUsers } from "../../../Redux/Actions";
import { Constants } from "../../Common/Constants";
import { RoutesUrl } from "../../Common/RoutesUrl";
import PageHeader from "../../Common/PageHeader";
import TableList from "../../Common/UiModel/TableList";
import ReactPagination from "../../Common/Fields/ReactPagination";
import usePermissions from "../../Common/Functions/usePermissions";

const ChallengeResponsePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { challengeuserlist } = useSelector((state) => state.Challenge);
  const [challengeUserData, setChallengeUserData] = useState([]);
  // Permissions
  const viewPermission = usePermissions(Constants.permission.CUSTOMER_VIEW);

  useEffect(() => {
    // Challenge User list API
    const data = {
      id,
    };
    dispatch(challengeUsers(data));
  }, []);

  useEffect(() => {
    // Set Challenge users data
    setChallengeUserData(challengeuserlist?.items);
  }, [challengeuserlist]);

  // Columns for Response Table List
  const columns = [
    {
      name: Constants.name,
      cell: (row) => (
        <>
          {viewPermission ? (
            <Link to={`${RoutesUrl.users}/${row?._id}`}>
              {row?.userId?.name || Constants.na}
            </Link>
          ) : (
            row?.userId?.name || Constants.na
          )}
        </>
      ),
    },
    {
      name: Constants.email,
      cell: (row) => row?.userId?.email || Constants.na,
    },
    {
      name: Constants.createdDate,
      cell: (row) => dayjs(row?.createdAt).format(Constants.dateFormat),
    },
  ];

  const handleOffset = (newOff) => {
    const data = {
      skip: newOff,
      limit: Constants.limitCount,
      id,
    };
    dispatch(challengeUsers(data));
  };

  return (
    <>
      <div className="mt-3">
        <PageHeader pagetitle={Constants.users} />
      </div>
      <TableList
        columns={columns}
        data={challengeUserData}
        defaultSortFieldId
        highlightOnHover
      />
      {challengeuserlist?.count > Constants.limitCount && (
        <ReactPagination
          itemsPerPage={Constants.limitCount}
          total={challengeuserlist?.total}
          newOffset={handleOffset}
        />
      )}
    </>
  );
};

export default ChallengeResponsePage;
